import "./ButtonSound.css";
import { useChatboxDispatchContext, useChatboxStateContext } from "../../../context/ChatboxContext";
import Sound from 'jsx:../../../assets/sound-max.svg';
import SoundMute from 'jsx:../../../assets/sound-mute.svg';
const ButtonSound = () => {

    const { valueToggleSound } = useChatboxStateContext();

    const dispatch = useChatboxDispatchContext();

    const toggleFocus = () => dispatch({ type: "toggleSound" })

    return (
        <button id="kwalys-sound" onClick={toggleFocus} className={valueToggleSound ? 'active' : ''}>
            {valueToggleSound ? <Sound/> : <SoundMute/>}
        </button>
    );
};

export default ButtonSound;